import {
  LAWCASE_CLIENT_FOLDER_QUERY,
  CLIENT_UPDATE_DOCUMENT_MUTATION,
  CLIENT_DELETE_DOCUMENT_MUTATION,
} from "./queries.js";
import { client } from "apollo.js";

const updateFolderCacheDelete = (store, params) => {
  const { lawcaseId, folderId, documentId } = params;

  try {
    // Read the data from our cache for this query.
    const data = store.readQuery({
      query: LAWCASE_CLIENT_FOLDER_QUERY,
      variables: { lawcaseId, folderId },
    });

    // Remove document
    const newDocuments = data.lawcaseClient.folder.documents.filter(
      (d) => d.id !== `${documentId}`,
    );

    const newData = {
      ...data,
      lawcaseClient: {
        ...data.lawcaseClient,
        folder: {
          ...data.lawcaseClient.folder,
          documents: newDocuments,
        },
      },
    };

    // Write our data back to the cache.
    store.writeQuery({
      query: LAWCASE_CLIENT_FOLDER_QUERY,
      variables: { lawcaseId, folderId },
      data: newData,
    });
  } catch (e) {}
};

export const updateDocument = async (lawcaseId, documentId, params) => {
  const result = await client.mutate({
    mutation: CLIENT_UPDATE_DOCUMENT_MUTATION,
    variables: { lawcaseId, documentId, params },
  });

  return result;
};

export const deleteDocument = async (lawcaseId, folderId, documentId) => {
  const result = await client.mutate({
    mutation: CLIENT_DELETE_DOCUMENT_MUTATION,
    variables: { lawcaseId, documentId },
    update: (store, { data: { deleteDocument } }) => {
      const params = {
        lawcaseId,
        folderId,
        documentId,
      };
      updateFolderCacheDelete(store, params);
    },
  });
  return result;
};
